//
export default [
    {
        text    : 'numero',
        value   : 'id',
    },
    {
        text    : 'periodo',
        value   : 'period_case',
    },
    {
        text    : 'rut',
        value   : ({ hr_employee }) => hr_employee.rut,
        format  : 'rut',
    },
    {
        text    : 'nombre',
        value   : ({ hr_employee }) => [ hr_employee.names, hr_employee.last_name1, hr_employee.last_name2 ].join( ' ' ),
    },
    {
        text    : 'base',
        align   : 'center',
        value   : ({ hr_contract }) => hr_contract.base_salary,
        format  : 'currency',
    },
    {
        text    : 'imponible',
        align   : 'center',
        value   : 'total_imponible',
        format  : 'currency',
    },
    {
        text    : 'no imponible',
        align   : 'center',
        value   : 'total_no_imponible',
        format  : 'currency',
    },
    {
        text    : 'haberes',
        align   : 'center',
        value   : 'total_haberes',
        format  : 'currency',
    },
    {
        text    : 'liquido',
        align   : 'center',
        value   : 'liquid_salary',
        format  : 'currency',
    },
    {
        text    : 'confirmada',
        align   : 'center',
        value   : 'confirmed',
        format  : 'boolean',
    },
]